import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = [ "additionalQuantity", "fulfilledCheckbox", "message" ]

  validateQuantity(event){
    const input = event.target;
    const index = input.dataset.index;
    const checkboxId = `fulfilledCheckbox_${index}`;
    const box = document.getElementById(checkboxId);
    const additionalQtyId = `additionalQuantity_${index}`;
    const additionalQty = document.getElementById(additionalQtyId);
    const maxQuantity = parseInt(input.dataset.quantity) || 0;
    const receivedQuantity = parseInt(input.dataset.received) || 0;
    const messageElement = this.messageTarget;
    let value = parseInt(input.value) || 0;

    if (value + receivedQuantity >= maxQuantity) {
      box.checked = true;
      additionalQty.value = maxQuantity - receivedQuantity;
      this.showToast("The quantity received has reached the maximum limit and has been marked as fulfilled.");
      messageElement.style.display = "block";
    } else {
      box.checked = false;
      messageElement.style.display = "none";
    }

    if (value > maxQuantity - receivedQuantity) {
      input.value = maxQuantity - receivedQuantity;
      value = maxQuantity - receivedQuantity;
    }
  }

  showToast(message) {
    const toastElement = this.messageTarget;
    toastElement.querySelector(".toast-body").textContent = message;
    const toast = new bootstrap.Toast(toastElement);
    toast.show();
  }
}
